// 裝置分組(CAM-24 Stage 3c,web)。
//
// 對齊 Android `DeviceGroupTabBar`/`orderedGroups` 與 iOS `DeviceListView` group chip bar:
// 分組來源=後端 per-user `device.group` 欄(device_user_relations.group),排序來源=
// `device_group_order` 偏好(GET/PUT /v3/me/preferences,跨裝置同步)。與 rooms.ts(本地
// localStorage)不同——本模組是純呈現/排序邏輯,所有讀寫都走 lib/api 的後端管線。
//
// 未分組裝置(group 空/未設)只出現在「全部」分頁,不另立分頁或區塊(對齊三端)。

import type { DeviceSummary } from './deviceModel';

/** 前端分組數上限(建立鈕在達此數時 disable)。後端硬上限為 50,此為 UI 克制上限,對齊 Android `MAX_DEVICE_GROUPS`。 */
export const MAX_DEVICE_GROUPS = 10;

/** device 的正規化分組名:trim 後空字串 → null(視為未分組)。 */
export function deviceGroupName(d: Pick<DeviceSummary, 'group'>): string | null {
  const g = d.group?.trim();
  return g ? g : null;
}

/**
 * 已知分組的顯示順序(對齊 Android/iOS `orderedGroups`):
 * 已知分組 = `order` 清單(含尚無成員的空分組) ∪ 裝置上實際出現的分組;
 * 先照 `order`、`order` 未涵蓋而裝置上有的分組再依「首次出現」順序追加。去重、忽略空名。
 */
export function orderedGroups(devices: Pick<DeviceSummary, 'group'>[], order: string[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  const push = (name: string | null | undefined) => {
    const n = name?.trim();
    if (n && !seen.has(n)) {
      seen.add(n);
      out.push(n);
    }
  };
  for (const g of order) push(g);
  for (const d of devices) push(deviceGroupName(d));
  return out;
}

/** 只挑屬於 `group` 的裝置(pure client filter);維持輸入順序。group 傳 null/'' → 回全部(「全部」分頁)。 */
export function devicesInGroup<T extends Pick<DeviceSummary, 'group'>>(devices: T[], group: string | null): T[] {
  if (!group) return devices;
  return devices.filter((d) => deviceGroupName(d) === group);
}
